import { Input } from 'antd';
import { useEffect } from 'react';

import { SearchIcon } from '../../icons';
import { getClassName } from '../_utils';

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  debounceMs?: number;
}

export function SearchInput({
  value,
  onChange,
  placeholder = 'Search...',
  className,
  disabled = false,
  debounceMs = 500,
}: Readonly<SearchInputProps>) {
  useEffect(() => {
    const getData = setTimeout(() => {
      onChange(value);
    }, debounceMs);

    return () => clearTimeout(getData);
  }, [value, onChange, debounceMs]);

  return (
    <Input
      placeholder={placeholder}
      prefix={<SearchIcon />}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={getClassName('search-input', [
        'export-btn',
        'print-hidden',
        ...(className ? [className] : []),
      ])}
      aria-label="Search"
      tabIndex={0}
      role="searchbox"
      disabled={disabled}
    />
  );
}
